module.exports = __webpack_public_path__ + "media/goforajourney/img/madrid-card-633592ca5bb4373007571d895f62ca64.jpeg";